<template>
  <div
    class="prose prose-base prose-neutral max-w-none leading-6 dark:prose-invert sm:prose-sm prose-headings:my-3 prose-headings:font-semibold first:prose-p:mt-0 last:prose-p:mb-0 prose-a:text-primary-600 hover:prose-a:text-primary-900"
  >
    <slot />
  </div>
</template>
